import { Button } from '../ui/Button';
import type { EventWithVenue } from './types';

interface EventCallsToActionProps {
  event: EventWithVenue;
  isAtCapacity: boolean;
  isSignedIn: boolean;
  onSignIn: () => void;
}

/**
 * The two bottom-of-page calls to action: the members-only club pitch and the
 * public registration control. Rendered as siblings so the page's vertical
 * rhythm is unchanged.
 */
export const EventCallsToAction = ({
  event,
  isAtCapacity,
  isSignedIn,
  onSignIn,
}: EventCallsToActionProps) => (
  <>
    {/* Members Only CTA */}
    {event.audience === 'members_only' && event.status === 'published' && (
      <div className="border-t border-gray-200 pt-6">
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 text-center">
          <p className="text-amber-800 font-semibold">
            This event is for wine club members
          </p>
          <p className="text-sm text-amber-700 mt-1">
            Join the winery's club or allocation list to attend exclusive events like this one.
          </p>
          {event.contactInfo?.email && (
            <a
              href={`mailto:${event.contactInfo.email}?subject=Interested in joining the wine club`}
              className="inline-block mt-3 px-4 py-2 bg-amber-600 text-white font-medium rounded-md hover:bg-amber-700"
            >
              Contact the Winery
            </a>
          )}
        </div>
      </div>
    )}

    {/* Registration Button */}
    {event.requiresReservation && event.status === 'published' && event.audience === 'public' && (
      <div className="border-t border-gray-200 pt-6">
        {isAtCapacity ? (
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-center">
            <p className="text-red-800 font-medium">
              This event is at capacity
            </p>
            <p className="text-sm text-red-600 mt-1">
              Registration is currently closed
            </p>
          </div>
        ) : isSignedIn ? (
          <Button
            variant="primary"
            size="lg"
            fullWidth
            onClick={() => {
              // TODO: Implement registration functionality
              alert('Registration functionality will be implemented in a future task');
            }}
          >
            Register for Event
          </Button>
        ) : (
          <div className="bg-primary-50 border border-primary-200 rounded-lg p-4 text-center">
            <p className="text-primary-800 font-medium">
              Sign in to register for this event
            </p>
            <Button
              variant="primary"
              size="md"
              className="mt-3"
              onClick={onSignIn}
            >
              Sign In
            </Button>
          </div>
        )}
      </div>
    )}
  </>
);
